// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZW1Di","footer":"styles_footer__2kPq3","passCodeTooltip":"styles_passCodeTooltip__19mv2"};